export const ROOT = `https://${
  window.location.hostname.split('.')[0]
}.localtest.me:8000`;

export const BASE_CART_ENDPOINT = '/store/cart';
export const CART_ITEM_ENDPOINT = `/store/online-ordering/cart/cart-item`;
// TODO: this will be refactored to be a separate API endpoint to empty
export const EMPTY_CART_ENDPOINT = CART_ITEM_ENDPOINT;
